import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { fundCard } from '@/services/cards';
import { CardFundingRequest, CardFundingResponse } from '@/types/cards';
import { TErrorResponse } from '@/types/error/error-response';

export const useCardFunding = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending, error, isSuccess, isError } = useMutation<
    CardFundingResponse,
    TErrorResponse,
    CardFundingRequest,
    unknown
  >({
    mutationKey: ['fund-card'],
    mutationFn: (request) => fundCard(request),
    onSuccess: (response) => {
      if (response.status === 'completed') {
        message.success('Card funded successfully');
        // Invalidate all card-related queries to refresh the UI
        queryClient.invalidateQueries({ queryKey: ['get-cards'] });
        queryClient.invalidateQueries({ queryKey: ['transactions'] });
      } else {
        console.error('Unexpected response status:', response.status);
        message.error('Failed to fund card: Unexpected response');
      }
    },
    onError: (error) => {
      console.error('Error funding card:', error);
      const errorMessage = error instanceof Error ? error.message : 'Failed to fund card';
      message.error(errorMessage);
    },
  });

  return {
    fundCardRequest: mutate,
    isLoading: isPending,
    isSuccess,
    isError,
    error,
  };
}; 